import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, DBRadioButton, ObjectiveFlag, DBDropDown, DBCheckBox, DBDecimalFieldObjective, DBCheckBoxRadioComment } from '_components';
import styles from './Common.module.css';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';

class SpeechFluency extends React.Component {

  handleSeverityClick(val) {
    if (val === false) {
        this.props.clearField(this.props.noteId, 'PTOBJECTIVESPEECH', 'OSNO', this.props.osno, 'OSFLUSEVERITYSTATUS');
        this.props.clearField(this.props.noteId, 'PTOBJECTIVESPEECH', 'OSNO', this.props.osno, 'OSFLUSEVERITYTXT');
    }
  }

  handleRateOfSpeechClick(val) {
    if (val === false) {
        this.props.clearField(this.props.noteId, 'PTOBJECTIVESPEECH', 'OSNO', this.props.osno, 'OSFLURATESTATUS');
        this.props.clearField(this.props.noteId, 'PTOBJECTIVESPEECH', 'OSNO', this.props.osno, 'OSFLURATETXT');
    }
  }

  handleDisfluencyClick(val) {
    if (val === false) {
        this.props.clearField(this.props.noteId, 'PTOBJECTIVESPEECH', 'OSNO', this.props.osno, 'OSFLUTYPEBLOCKS');
        this.props.clearField(this.props.noteId, 'PTOBJECTIVESPEECH', 'OSNO', this.props.osno, 'OSFLUTYPEREPETITIONS');
        this.props.clearField(this.props.noteId, 'PTOBJECTIVESPEECH', 'OSNO', this.props.osno, 'OSFLUTYPEPROLONGATIONS');
    }
  }

  handleSecCharClick(val) {
    if (val === false) {
        this.props.clearField(this.props.noteId, 'PTOBJECTIVESPEECH', 'OSNO', this.props.osno, 'OSFLUSECONDTENSION');
        this.props.clearField(this.props.noteId, 'PTOBJECTIVESPEECH', 'OSNO', this.props.osno, 'OSFLUSECONDOTHER');
    }
  }

    render() {
        return (
          <div>
                
                <div className={styles.formRowSetting}>
                    {this.props.flagged ? <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} flagText='Fluency' /> : <div className={styles.flag} / >}
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSFLUSTATUS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radioSpace}
                            />   
                            
                            
                            <div className={styles.underHeaderRadioSpace} />

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSFLUSTATUS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
 
                    </div>

                    <div className={styles.spanGap}>
                        <b>Comments</b>
                    </div>

                <div className={styles.formRowSetting}>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSFLUCOMMENTS'
                        className={styles.txtAreaGap}
                    />
                </div>

                <div className={styles.formRowSetting}>
                    {this.props.severityFlagged 
                    ? 
                    <ObjectiveFlag className={styles.flag} flagged={this.props.severityFlagged} flagText='Severity' /> : <div className={styles.flag}/>}
                        
                            
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSFLUSEVERITY'
                        label='Severity'
                        onClick={(event) => this.handleSeverityClick(event)}
                    />
                    <DBDropDown
                        field='OSFLUSEVERITYSTATUS'
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        className={styles.dropDown}
                        disabled={!this.props.severityFlagged}
                        customOptions={
                            [
                                {id: 1, value: 'Very Mild'},
                                {id: 2, value: 'Mild'},
                                {id: 3, value: 'Moderate'},
                                {id: 4, value: 'Severe'},
                                {id: 5, value: 'Very Severe'}
                            ]
                        }
                    />
                </div>

                {this.props.severityFlagged 
                  ? (
                <div className={styles.formRow}>
                  <DBTextAreaObjective
                      noteId={this.props.noteId}
                      entity='PTOBJECTIVESPEECH'
                      entityKeyColumn='OSNO'
                      entityKeyValue={this.props.osno}
                      field='OSFLUSEVERITYTXT'
                      className={styles.txtAreaGap}
                  />
                </div>) :null}

                <div className={styles.formRow}>
                <DBCheckBoxRadioComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSFLURATE'
                         className={styles.checkbox}
                         label='Rate of Speech'
                         textAreaStyle={styles.commentTextArea}
                         disabledOptions={!this.props.rateOfSpeechFlagged}
                         disabledTxt={!this.props.rateOfSpeechFlagged}
                         onClick={(event) => this.handleRateOfSpeechClick(event)}
                         options={[{
                            id: 1,
                            label: 'Normal',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSFLURATESTATUS',
                            selectedValue: 'Normal',
                            type: 'bit'
                          },
                          {
                            id: 2,
                            label: 'Slow',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSFLURATESTATUS',
                            selectedValue: 'Slow',
                            type: 'bit'
                          },
                          {
                            id: 3,
                            label: 'Rapid',
                            noteId: this.props.noteId,
                            entity: 'PTOBJECTIVESPEECH',
                            entityKeyColumn: 'OSNO',
                            entityKeyValue: this.props.osno,
                            field: 'OSFLURATESTATUS',
                            selectedValue: 'Rapid',
                            type: 'bit'
                          }
                        ]}
                    />
                </div>


                <div className={styles.formRow}>
                  <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSFLUTYPE'
                        label='Type of Disfluency'
                        className={styles.disfluecy}
                        onClick={(event) => this.handleDisfluencyClick(event)}
                    />
               
                             
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSFLUTYPEBLOCKS'
                        disabled={!this.props.disfluecyDisabled}
                        label='Blocks'
                        className={styles.blocks}
                    />
                             
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSFLUTYPEREPETITIONS'
                        label='Repetitions'
                        disabled={!this.props.disfluecyDisabled}
                        className={styles.repetitions}
                    />
                             
                     <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSFLUTYPEPROLONGATIONS'
                        disabled={!this.props.disfluecyDisabled}
                        label='Prolongations'
                    />
                </div>

                <div className={styles.formRow}>
                  <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSFLUSECOND'
                        label='Secondary Characteristics'
                        className={styles.disfluecy}
                        onClick={(event) => this.handleSecCharClick(event)}
                    />
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSFLUSECONDTENSION'
                        label='Tension / Grimace'
                        className={styles.tension}
                        disabled={!this.props.SecCharDisabled}
                    />
               
                             
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSFLUSECONDOTHER'
                        label='Other'
                        className={styles.other}
                        disabled={!this.props.SecCharDisabled}
                    />
             
                </div>
                {this.props.otherSelected && 
                    (<div className={styles.textFieldRow}>
                 <div className={styles.formRowSetting}>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSFLUSECONDOTHERTXT'
                        className={styles.txtAreaOther}
                    />
                </div>
                </div>)
                }
                

                <div className={styles.textFieldRow}>
                    <label>Total disfluencies: </label>
                    <span className={styles.radioSpace}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPEECH'
                            entityKeyColumn='OSNO'
                            entityKeyValue={this.props.osno}
                            field='OSFLUSCORE'
                            className={styles.circumInput}
                            min={0}
                        />
                    </span>
                    <label className={styles.radioSpace}>per</label>
                    <span className={styles.radioSpace}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPEECH'
                            entityKeyColumn='OSNO'
                            entityKeyValue={this.props.osno}
                            field='OSFLUTOTAL'
                            className={styles.circumInput}
                            min={0}
                        />
                    </span>
                </div>

      </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch)
    };
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let osno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPEECH)
    .find(key => (state.entities.notes.PTOBJECTIVESPEECH[key].OSEVNO === pk && noteType === 1)
        || (state.entities.notes.PTOBJECTIVESPEECH[key].OSNTNO === pk && noteType !== 1)));
        
    return {
        noteId: noteId,
        osno: osno,
        flagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSTATUS !== undefined 
          && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSTATUS !== null 
          && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSTATUS !== 'WNL'),
        severityFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSEVERITY !== undefined 
          && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSEVERITY !== null 
          && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSEVERITY),
        rateOfSpeechFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLURATE !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLURATE !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLURATE),
        disfluecyDisabled: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUTYPE !== undefined 
              && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUTYPE !== null 
              && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUTYPE),
        SecCharDisabled: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSECOND !== undefined 
          && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSECOND !== null 
          && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSECOND),
        otherSelected: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSECONDOTHER !== undefined 
          && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSECONDOTHER !== null 
          && state.entities.notes.PTOBJECTIVESPEECH[osno].OSFLUSECONDOTHER),
    };
}

const connectedSpeechFluency = connect(mapStateToProps, mapDispatchToProps)(SpeechFluency);
export { connectedSpeechFluency as SpeechFluency };


